import React from "react";
import clsx from "clsx";

import { ReactComponent as PieCart } from "../../../assets/images/Career/Reference/step_pie-chart.svg";
import { ReactComponent as Map } from "../../../assets/images/Career/Reference/step_map.svg";
import challengeSheetImg from "../../../assets/images/Career/Reference/step_challenge-sheet.webp";
import commonStyles from "../CareerReference.module.scss";

import styles from "./Step.module.scss";

const Step = () => {
  return (
    <div className={styles.wrapper}>
      <p className={clsx(commonStyles.title, styles.title)}>
        "将来"を広げる、
        <br className={commonStyles.isSp} />
        キャリア開拓モードの
        <br className={commonStyles.isSp} />
        4つのステップ
      </p>
      <ul className={styles.list}>
        <li className={styles.item}>
          <div className={styles.group}>
            <p className={styles.title}>
              <span className={styles.no}>1.</span>
              キャリア開拓シートを入力する
            </p>
            <p className={styles.text}>
              好きなことや気になることを入力します。
              <br className={commonStyles.isPc} />
              「ない」でも大丈夫！
            </p>
          </div>
          <div className={styles.card}>
            <p className={styles.theme}>Q1.今の自分に関して</p>
            <p className={styles.title}>
              今、大切なもの・好きなこと・
              <br />
              夢中になれることは？
            </p>
            <p className={clsx(styles.text, styles.isHeight)}>
              サッカーが好き。
              <br />
              映画やアニメを見るのが好き
            </p>
          </div>
        </li>
        <li className={clsx(styles.item, styles.isFlexDirection)}>
          <div className={styles.group}>
            <p className={styles.title}>
              <span className={styles.no}>2.</span>
              キャリア開拓MAPを確認する
            </p>
            <p className={styles.text}>
              シートに答えると、「キャリア開拓MAP」が表示されます。
              <br className={commonStyles.isPc} />
              キャリア開拓MAPは、「自分の今・未来」と「社会の今・未来」をつなげて考えることができるツールです。興味や強みから、「こんな未来があるかも！」と新しい可能性を提案し、新しい選択肢を広げる手助けをします。
            </p>
          </div>
          <Map className={styles.img} />
        </li>
        <li className={styles.item}>
          <div className={styles.group}>
            <p className={styles.title}>
              <span className={styles.no}>3.</span>
              キャリア開拓クエスチョンにトライする
            </p>
            <p className={styles.text}>
              シートの情報をもとに、キャリア開拓モードから
              あなた専用の将来を広げる問いを投げかけます。
              <br className={commonStyles.isPc} />
              「自分ってどんな人間？」「この仕事の未来は？」
              そんな新しい視点を得て考えることで、考えが深まっていきます。
            </p>
          </div>
          <div className={styles.card}>
            <PieCart className={styles.pieChart} />
            <p className={styles.theme}>Q.キャリア開拓クエスチョン</p>
            <p className={styles.title}>
              サッカーを好きだと思ったのはいつ、
              <br />
              どんな体験から？
            </p>
            <p className={styles.text}>
              小さい頃に試合を見に行ってから。 走る速さに感動した
            </p>
          </div>
        </li>
        <li className={styles.item}>
          <div className={styles.group}>
            <p className={styles.title}>
              <span className={styles.no}>4.</span>
              進路決定チャレンジシートを書いてみる
            </p>
            <p className={styles.text}>
              今の自分の未来について、考えていることをかいてみよう。
              <br />
              はっきり決まっていなくても大丈夫。今まで記入したことの中から気になるものを選んだり、どんな生活をしたいか考えたり…自分の未来に目を向けるところから始めてみよう。
            </p>
          </div>
          <div className={styles.imageGroup}>
            <p className={styles.imageLabel}>＼学期や学年の節目に／</p>
            <img
              src={challengeSheetImg}
              className={styles.img}
              alt="進路決定チャレンジシート"
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Step;
